import {EMBED_MODE, UIStore} from '../store';

const handlerBlockIfPreview = (event: Event) => {
	if(UIStore.embedMode !== EMBED_MODE.NONE) {
		console.debug(`disable-if-embedded directive preventing ${event.type} event on ${(event.target as HTMLElement).tagName} element`);
		event.preventDefault();
		event.stopImmediatePropagation();
		event.stopPropagation();
	}
};

const SELECTORS_TO_DISABLE = '.q-btn, .q-checkbox, .q-field';

/**
 * makes UI appear disabled and swallows click events if UIStore.isPreview
 *
 * N.B.: Once bound, this does not monitor UIStore.isPreview. To do so, we could
 *       probably pass the value in for binding and add/remove listeners as it changes,
 *       but that seems overkill for our current use cases, where the value doesn't
 *       change within a session.
 */
export const DirectiveDefinitionDisableIfEmbedded = {
	bind: (el: HTMLElement) => {
		el.addEventListener('click', handlerBlockIfPreview, {capture: true});

		if(UIStore.embedMode !== EMBED_MODE.NONE) {
			// apply globally-available Quasar helper classes
			el.classList.add('cursor-not-allowed');
			el.querySelectorAll(SELECTORS_TO_DISABLE).forEach(qEl => qEl.classList.add('disabled'));
		}
	},
	unbind: (el: HTMLElement) => {
		el.removeEventListener('click', handlerBlockIfPreview, {capture: true});
		el.classList.remove('cursor-not-allowed');
		el.querySelectorAll(SELECTORS_TO_DISABLE).forEach(qEl => qEl.classList.remove('disabled'));
	}
};
